import { render } from "./CircularLinkPopup.vue?vue&type=template&id=15afdc86&scoped=true&ts=true"
import script from "./CircularLinkPopup.vue?vue&type=script&lang=ts"
export * from "./CircularLinkPopup.vue?vue&type=script&lang=ts"

import "./CircularLinkPopup.vue?vue&type=style&index=0&id=15afdc86&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15afdc86"]])

export default __exports__